export const sideNavbar = {
  home: "Inicio",
  games: "Slots",
  allGames: "Juegos",
  lottery: "Lotería",
  raffle: "Rifa",
  providers: "Elige tu proveedor favorito",
  categories: "Categorias",
  casino: "Casino Live",
  casinos: "Casino Live",
  poker: "Poker",
  sports: "Deportes",
  allSports: "Deportes",
  soccer: "Fútbol",
  baseball: "Beisbol",
  basketball: "Basket",
  e_sports: "E-Sports",
  nfl: "NFL",
  allPageSports: "Ir a Todos",
  parleyMenu: "Parley",
  allPageGames: "Ir a Todos",
  support: "Soporte",
  live_casino: "Casino en Vivo",
  bingo: "Bingo",
  horses: "Caballos",
  hipism: "Hipismo",
  News: "Noticias",
  gameFeed: "Feed de Juegos",
  miniJuegos: "Mini Juegos",
  winnerTestimonials: "Testimonios",
  sidebarSectionMain: "PRINCIPAL",
  sidebarSectionGames: "JUEGOS",
  sidebarSectionMore: "MÁS",
  sidebarSectionActions: "ACCIONES",
  sidebarMyFavorites: "Mis Favoritos",
};